// The primary operating accounting company (Aliace SPA). This UUID was historically
// copy-pasted as a literal across the contabilidad / AP surfaces (ALIACE_SPA_ID); new code
// and the multiempresa AP work should import it from here instead of re-declaring it.
export const ALIACE_SPA_ID = "809d3197-9371-4cbb-b544-aadbd29940d6";
